import { render } from "./buttonEnat copy.vue?vue&type=template&id=01743609&scoped=true"
import script from "./buttonEnat copy.vue?vue&type=script&lang=js"
export * from "./buttonEnat copy.vue?vue&type=script&lang=js"

import "./buttonEnat copy.vue?vue&type=style&index=0&id=01743609&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01743609"]])

export default __exports__